import { TemplateViewControlType } from 'src/app/modules/communications/store/communications/communications.model';
import { TemplateDesignImageElement } from './controls/image-control/image-control.component';
import { TemplateDesignTextElement } from './controls/text-control/text-control.component';
import { TemplateDesignDividerElement } from './controls/divider-control/divider-control.component';
import { TemplateDesignButtonElement } from './controls/button-control/button-control.component';
import { TemplateDesignMessageTextElement } from './controls/message-text-control/message-text-control.component';
import { TemplateDesignConfirmationElement } from './controls/confirmation-control/confirmation-control.component';
import { TemplateDesignFormFieldElement } from './controls/form-field-control/form-field-control.component';
import { TemplateDesignAttachmentsElement } from './controls/attachments-control/attachments-control.component';
import { TemplateDesignTimelineElement } from './controls/timeline-control/timeline-control.component';
import { TemplateDesignMapElement } from './controls/map-control/map-control.component';
import { TemplateDesignAssetsElement } from './controls/assets-control/assets-control.component';
import { TtsNotificationMessageControlComponent } from './controls/tts-notification-message-control/tts-notification-message-control.component';
import { TtsConfirmationQuestionComponent } from './controls/tts-confirmation-question/tts-confirmation-question.component';
import { TtsTextControlComponent } from './controls/tts-text-control/tts-text-control.component';
import { TemplateControlRegistration } from './design-elements.models';
import { SmsNotificationMessageControl } from './controls/sms-notification-message-control/sms-notification-message-control.component';
import { SlackTemplateDesignConfirmationElement } from './controls/slack-confirmation-control/slack-confirmation-control.component';
import { ChannelUIds } from 'src/app/modules/communications/store/communications/communications.model';
import { SmsConfirmationControlComponent } from './controls/sms-confirmation-control/sms-confirmation-control.component';
import { WhatsappNotificationMessageControlComponent } from './controls/whatsapp-notification-message-control/whatsapp-notification-message-control.component';
import { WhatsappConfirmationControlComponent } from './controls/whatsapp-confirmation-control/whatsapp-confirmation-control.component';
import { HeaderControlComponent } from './controls/header-control/header-control.component';
import { TemplateDesignNotificationStatusElement } from './controls/notification-status-control/notification-status-control.component';
import { SmsTextControlComponent } from './controls/sms-text-control/sms-text-control.component';
import { PushTextControlComponent } from './controls/push-text-control/push-text-control.component';
import { GwtsConfirmationControlComponent } from './controls/gwts-confirmation-control/gwts-confirmation-control.component';
import { GwtsNotificationMessageControlComponent } from './controls/gtws-notification-message-control/gwts-notification-message-control.component';

export const TemplateDesignElementsRegistration: TemplateControlRegistration[] = [
  //
  // sendgrid email
  //
  {
    viewControlType: TemplateViewControlType.Image,
    channelUId: ChannelUIds.SendGridEmailChannelUId,
    component: TemplateDesignImageElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Image
  },
  {
    viewControlType: TemplateViewControlType.Text,
    channelUId: ChannelUIds.SendGridEmailChannelUId,
    component: TemplateDesignTextElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Text
  },
  {
    viewControlType: TemplateViewControlType.Header,
    channelUId: ChannelUIds.SendGridEmailChannelUId,
    component: HeaderControlComponent,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Header
  },
  {
    viewControlType: TemplateViewControlType.Divider,
    channelUId: ChannelUIds.SendGridEmailChannelUId,
    component: TemplateDesignDividerElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Divider
  },
  {
    viewControlType: TemplateViewControlType.Button,
    channelUId: ChannelUIds.SendGridEmailChannelUId,
    component: TemplateDesignButtonElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Button
  },
  {
    viewControlType: TemplateViewControlType.NotificationMessage,
    channelUId: ChannelUIds.SendGridEmailChannelUId,
    component: TemplateDesignMessageTextElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.NotificationMessage
  },
  {
    viewControlType: TemplateViewControlType.ConfirmationMessage,
    channelUId: ChannelUIds.SendGridEmailChannelUId,
    component: TemplateDesignConfirmationElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.ConfirmationMessage
  },
  {
    viewControlType: TemplateViewControlType.FormField,
    channelUId: ChannelUIds.SendGridEmailChannelUId,
    component: TemplateDesignFormFieldElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.FormField
  },
  {
    viewControlType: TemplateViewControlType.Attachments,
    channelUId: ChannelUIds.SendGridEmailChannelUId,
    component: TemplateDesignAttachmentsElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Attachments
  },
  {
    viewControlType: TemplateViewControlType.NotificationRecipientsStatus,
    channelUId: ChannelUIds.SendGridEmailChannelUId,
    component: TemplateDesignNotificationStatusElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.NotificationRecipientsStatus
  },
  {
    viewControlType: TemplateViewControlType.Timeline,
    channelUId: ChannelUIds.SendGridEmailChannelUId,
    component: TemplateDesignTimelineElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Timeline
  },
  {
    viewControlType: TemplateViewControlType.Map,
    channelUId: ChannelUIds.SendGridEmailChannelUId,
    component: TemplateDesignMapElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Map
  },
  {
    viewControlType: TemplateViewControlType.SelectedAssets,
    channelUId: ChannelUIds.SendGridEmailChannelUId,
    component: TemplateDesignAssetsElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.SelectedAssets
  },

  //
  // topo email
  //
  {
    viewControlType: TemplateViewControlType.Image,
    channelUId: ChannelUIds.TopoEmailChannelUId,
    component: TemplateDesignImageElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Image
  },
  {
    viewControlType: TemplateViewControlType.Text,
    channelUId: ChannelUIds.TopoEmailChannelUId,
    component: TemplateDesignTextElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Text
  },
  {
    viewControlType: TemplateViewControlType.Header,
    channelUId: ChannelUIds.TopoEmailChannelUId,
    component: HeaderControlComponent,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Header
  },
  {
    viewControlType: TemplateViewControlType.Divider,
    channelUId: ChannelUIds.TopoEmailChannelUId,
    component: TemplateDesignDividerElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Divider
  },
  {
    viewControlType: TemplateViewControlType.Button,
    channelUId: ChannelUIds.TopoEmailChannelUId,
    component: TemplateDesignButtonElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Button
  },
  {
    viewControlType: TemplateViewControlType.NotificationMessage,
    channelUId: ChannelUIds.TopoEmailChannelUId,
    component: TemplateDesignMessageTextElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.NotificationMessage
  },
  {
    viewControlType: TemplateViewControlType.ConfirmationMessage,
    channelUId: ChannelUIds.TopoEmailChannelUId,
    component: TemplateDesignConfirmationElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.ConfirmationMessage
  },
  {
    viewControlType: TemplateViewControlType.FormField,
    channelUId: ChannelUIds.TopoEmailChannelUId,
    component: TemplateDesignFormFieldElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.FormField
  },

  {
    viewControlType: TemplateViewControlType.NotificationRecipientsStatus,
    channelUId: ChannelUIds.TopoEmailChannelUId,
    component: TemplateDesignNotificationStatusElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.NotificationRecipientsStatus
  },
  {
    viewControlType: TemplateViewControlType.Timeline,
    channelUId: ChannelUIds.TopoEmailChannelUId,
    component: TemplateDesignTimelineElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Timeline
  },
  {
    viewControlType: TemplateViewControlType.Map,
    channelUId: ChannelUIds.TopoEmailChannelUId,
    component: TemplateDesignMapElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Map
  },
  {
    viewControlType: TemplateViewControlType.SelectedAssets,
    channelUId: ChannelUIds.TopoEmailChannelUId,
    component: TemplateDesignAssetsElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.SelectedAssets
  },

  //
  // slack
  //
  {
    viewControlType: TemplateViewControlType.Text,
    channelUId: ChannelUIds.SlackChannelUId,
    component: TemplateDesignTextElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Text
  },
  {
    viewControlType: TemplateViewControlType.Divider,
    channelUId: ChannelUIds.SlackChannelUId,
    component: TemplateDesignDividerElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Divider
  },
  {
    viewControlType: TemplateViewControlType.Button,
    channelUId: ChannelUIds.SlackChannelUId,
    component: TemplateDesignButtonElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Button
  },
  {
    viewControlType: TemplateViewControlType.NotificationMessage,
    channelUId: ChannelUIds.SlackChannelUId,
    component: TemplateDesignMessageTextElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.NotificationMessage
  },
  {
    viewControlType: TemplateViewControlType.ConfirmationMessage,
    channelUId: ChannelUIds.SlackChannelUId,
    component: SlackTemplateDesignConfirmationElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.ConfirmationMessage
  },
  {
    viewControlType: TemplateViewControlType.FormField,
    channelUId: ChannelUIds.SlackChannelUId,
    component: TemplateDesignFormFieldElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.FormField
  },
  {
    viewControlType: TemplateViewControlType.NotificationRecipientsStatus,
    channelUId: ChannelUIds.SlackChannelUId,
    component: TemplateDesignNotificationStatusElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.NotificationRecipientsStatus
  },
  {
    viewControlType: TemplateViewControlType.Map,
    channelUId: ChannelUIds.SlackChannelUId,
    component: TemplateDesignMapElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Map
  },
  {
    viewControlType: TemplateViewControlType.SelectedAssets,
    channelUId: ChannelUIds.SlackChannelUId,
    component: TemplateDesignAssetsElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.SelectedAssets
  },

  //
  // teams
  //
  {
    viewControlType: TemplateViewControlType.Text,
    channelUId: ChannelUIds.MicrosoftTeamsChannelUId,
    component: TemplateDesignTextElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Text
  },
  {
    viewControlType: TemplateViewControlType.Divider,
    channelUId: ChannelUIds.MicrosoftTeamsChannelUId,
    component: TemplateDesignDividerElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Divider
  },
  {
    viewControlType: TemplateViewControlType.Button,
    channelUId: ChannelUIds.MicrosoftTeamsChannelUId,
    component: TemplateDesignButtonElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Button
  },
  {
    viewControlType: TemplateViewControlType.NotificationMessage,
    channelUId: ChannelUIds.MicrosoftTeamsChannelUId,
    component: TemplateDesignMessageTextElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.NotificationMessage
  },
  {
    viewControlType: TemplateViewControlType.ConfirmationMessage,
    channelUId: ChannelUIds.MicrosoftTeamsChannelUId,
    component: TemplateDesignConfirmationElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.ConfirmationMessage
  },
  {
    viewControlType: TemplateViewControlType.FormField,
    channelUId: ChannelUIds.MicrosoftTeamsChannelUId,
    component: TemplateDesignFormFieldElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.FormField
  },
  {
    viewControlType: TemplateViewControlType.Map,
    channelUId: ChannelUIds.MicrosoftTeamsChannelUId,
    component: TemplateDesignMapElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Map
  },
  {
    viewControlType: TemplateViewControlType.SelectedAssets,
    channelUId: ChannelUIds.MicrosoftTeamsChannelUId,
    component: TemplateDesignAssetsElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.SelectedAssets
  },

  //
  // twilio - text to speech
  //
  {
    viewControlType: TemplateViewControlType.NotificationMessage,
    channelUId: ChannelUIds.TwilioTtsChannelUId,
    component: TtsNotificationMessageControlComponent,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.NotificationMessage
  },
  {
    viewControlType: TemplateViewControlType.ConfirmationMessage,
    channelUId: ChannelUIds.TwilioTtsChannelUId,
    component: TtsConfirmationQuestionComponent,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.ConfirmationMessage
  },
  {
    viewControlType: TemplateViewControlType.Text,
    channelUId: ChannelUIds.TwilioTtsChannelUId,
    component: TtsTextControlComponent,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Text
  },

  //
  // SMS
  //
  {
    viewControlType: TemplateViewControlType.NotificationMessage,
    channelUId: ChannelUIds.TwilioChannelUId,
    component: SmsNotificationMessageControl,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.NotificationMessage
  },
  {
    viewControlType: TemplateViewControlType.ConfirmationMessage,
    channelUId: ChannelUIds.TwilioChannelUId,
    component: SmsConfirmationControlComponent,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.ConfirmationMessage
  },
  {
    viewControlType: TemplateViewControlType.Text,
    channelUId: ChannelUIds.TwilioChannelUId,
    component: SmsTextControlComponent,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Text
  },
  {
    viewControlType: TemplateViewControlType.NotificationMessage,
    channelUId: ChannelUIds.HorizonSmsChannelUId,
    component: SmsNotificationMessageControl,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.NotificationMessage
  },
  {
    viewControlType: TemplateViewControlType.ConfirmationMessage,
    channelUId: ChannelUIds.HorizonSmsChannelUId,
    component: SmsConfirmationControlComponent,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.ConfirmationMessage
  },
  {
    viewControlType: TemplateViewControlType.Text,
    channelUId: ChannelUIds.HorizonSmsChannelUId,
    component: SmsTextControlComponent,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Text
  },

  //
  // Whatsapp
  //
  {
    viewControlType: TemplateViewControlType.NotificationMessage,
    channelUId: ChannelUIds.WhatsAppChannelUId,
    component: WhatsappNotificationMessageControlComponent,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.NotificationMessage
  },
  {
    viewControlType: TemplateViewControlType.ConfirmationMessage,
    channelUId: ChannelUIds.WhatsAppChannelUId,
    component: WhatsappConfirmationControlComponent,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.ConfirmationMessage
  },

  //
  // Push
  //
  {
    viewControlType: TemplateViewControlType.Text,
    channelUId: ChannelUIds.HorizonMobilePushChannelUId,
    component: TemplateDesignTextElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Text
  },
  {
    viewControlType: TemplateViewControlType.Summary,
    channelUId: ChannelUIds.HorizonMobilePushChannelUId,
    component: PushTextControlComponent,
    desc: 'COMMUNICATIONS.DESIGNER.SUMMARY',
    singleInstance: true
  },
  {
    viewControlType: TemplateViewControlType.NotificationMessage,
    channelUId: ChannelUIds.HorizonMobilePushChannelUId,
    component: TemplateDesignMessageTextElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.NotificationMessage,
    singleInstance: true
  },
  {
    viewControlType: TemplateViewControlType.ConfirmationMessage,
    channelUId: ChannelUIds.HorizonMobilePushChannelUId,
    component: TemplateDesignConfirmationElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.ConfirmationMessage,
    singleInstance: true
  },
  {
    viewControlType: TemplateViewControlType.FormField,
    channelUId: ChannelUIds.HorizonMobilePushChannelUId,
    component: TemplateDesignFormFieldElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.FormField
  },
  {
    viewControlType: TemplateViewControlType.Divider,
    channelUId: ChannelUIds.HorizonMobilePushChannelUId,
    component: TemplateDesignDividerElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Divider
  },
  {
    viewControlType: TemplateViewControlType.Map,
    channelUId: ChannelUIds.HorizonMobilePushChannelUId,
    component: TemplateDesignMapElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Map
  },
  {
    viewControlType: TemplateViewControlType.Timeline,
    channelUId: ChannelUIds.HorizonMobilePushChannelUId,
    component: TemplateDesignTimelineElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Timeline
  },
  {
    viewControlType: TemplateViewControlType.SelectedAssets,
    channelUId: ChannelUIds.HorizonMobilePushChannelUId,
    component: TemplateDesignAssetsElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.SelectedAssets
  },
  {
    viewControlType: TemplateViewControlType.Image,
    channelUId: ChannelUIds.HorizonMobilePushChannelUId,
    component: TemplateDesignImageElement,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Image
  },


  //
  // Gwts
  //
  {
    viewControlType: TemplateViewControlType.NotificationMessage,
    channelUId: ChannelUIds.GwtsMobileChannelUId,
    component: GwtsNotificationMessageControlComponent,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.NotificationMessage,
    singleInstance: true
  },
  {
    viewControlType: TemplateViewControlType.Text,
    channelUId: ChannelUIds.GwtsMobileChannelUId,
    component: PushTextControlComponent,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.Text,
    singleInstance: true
  },
   {
    viewControlType: TemplateViewControlType.ConfirmationMessage,
    channelUId: ChannelUIds.GwtsMobileChannelUId,
    component: GwtsConfirmationControlComponent,
    desc: 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-' + TemplateViewControlType.ConfirmationMessage
  }
];
